import { connect, MapStateToProps } from "react-redux";

import { IAppState } from "@multiweb/types/react";
import { getInteractive } from "../../../selectors";
import { LOVAttributeComponent, LOVAttributeComponentProps } from "../../components/LOVAttributeComponent";

export type LOVAttributeProps = Omit<LOVAttributeComponentProps, "interactive">;

type StateProps = Pick<LOVAttributeComponentProps, "interactive">;

const mapStateToProps: MapStateToProps<StateProps, LOVAttributeProps, IAppState> = (
    state,
    { dataSourceKey },
) => ({
    interactive: getInteractive(state, dataSourceKey),
});

export const LOVAttribute = connect(mapStateToProps)(LOVAttributeComponent);
